import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService: AuthService = inject(AuthService);
  
  // Evitar bucles infinitos en la ruta raíz
  if (state.url === '/' || state.url === '/auth') {
    return true;
  }
  
  if ((!authService.isLoggedIn() || !authService.getToken())) {
    authService.signOutApply();
    await router.navigate(['/'], { queryParams: { 'redirect': state.url } });
    return false;
  }
  
  // Solo llamar signInApply si no hay usuario y hay token
  if (!authService.getUser() && authService.getToken()) {
    try {
      await authService.signInApply(authService.getToken()!);
    } catch (error) {
      console.error('Error en signInApply:', error);
      authService.signOutApply();
      await router.navigate(['/']);
      return false;
    }
  }

  return true;
};